// @flow

import axios      from 'axios';
import RoutesAPI  from './Routes';

let API_URL = '';
if( process.env.REACT_APP_API_URL ) {
  API_URL = process.env.REACT_APP_API_URL;
}

// Requests
const requests = {
  post: (url: string, body: any) => {
    return axios.post(API_URL + url, body);
  },

  get: (url: string, body: any) => {
    return axios.get(API_URL + url, body);
  }
};

const OfferAPI = {
  getCompareOffers: (application_id: number) => {
    return requests.get(RoutesAPI.offer_compare_offers() + '/' + application_id, {});
  },

  postCompareOffers: (application_id: number, data: any) => {
    return requests.post(RoutesAPI.offer_compare_offers() + '/' + application_id, data);
  },

  getOfferView: (id: number) => {
    return requests.get(RoutesAPI.offer_get_application(id), {});
  }
}

export default OfferAPI;



// WEBPACK FOOTER //
// ./src/api/OfferAPI.js